export const manualBooking: Record<string, readonly [string, string, string, string]> = {};
